export default function providerToAmount(PROVIDERS, $filter) {
    return (amount, provider, currency_to, divide, parameters) => {
        var divideField = parameters.from_amount ? 'from_amount' : 'to_amount';

        var divideBy = 1;
        var fractionSize = 2;

        if ((provider === PROVIDERS.OFFICIAL || provider === PROVIDERS.COMMERCIAL) && divide) {
            divideBy = parameters[divideField];
            fractionSize = 6;
        }
        return $filter('number')(amount / divideBy, fractionSize);
    }
}

providerToAmount.$inject = ['PROVIDERS', '$filter'];